
// React Imports
import { NUMBER_REGEX } from 'constants/Constants';
import React,{useRef} from 'react';

// Package Imports
import { AsyncTypeahead } from 'react-bootstrap-typeahead';

// CSS Imports
require('normalize.css/normalize.css');
require('styles/App.css');

const TypeHead = (props) => {

  const inputFieldRef = useRef();


  const filterBy = () => true;

  return (
    <AsyncTypeahead
      filterBy={filterBy}
      id="async-type-head"
      isLoading={false}
      labelKey="label"
      ref={inputFieldRef}
      minLength={props.minLength}
      maxLength={props.maxLength}
      onSearch={props.onSearch}
      options={props.menuList}
      placeholder={props.placeholder}
      onKeyDown={(e) => {
        if (inputFieldRef.current.items.length > 0 && e.keyCode === 13) {
          document.getElementById('async-type-head').style.display = 'none'
          // props.formControllerRef.$("location").value = inputFieldRef.current.items
          // if(props.submitData) {
          //   props.submitData()
          // }
        }
      }}
      inputProps={
        {maxLength:6}
      }
      onInputChange={(value) => {
        if(!NUMBER_REGEX.test(value)){
          inputFieldRef.current.clear()
        }
      }}
      className='textForm font-size-12 font-weight-light w-100 border-0'
      {...props}
    />
  );

};
export default TypeHead;
